import React, { useLayoutEffect, useRef } from 'react'
import { InputNumber } from 'antd'

const productName = title => {
  const name = String(title || '').trim()
  return name || 'this product'
}

/** Screen reader: "In stock for Sourdough Bloomer" */
export const stockTakeFieldAria = (field, title) =>
  `${field} for ${productName(title)}`

/**
 * Stepper buttons: "Increase in stock for Sourdough Bloomer"
 * and Par / wastage equivalents.
 */
export const stockTakeStepperAria = (field, title, delta = 1) => {
  const name = productName(title)
  if (delta < 0) return `Decrease ${field} for ${name}`
  if (delta > 1) return `Increase ${field} by ${delta} for ${name}`
  return `Increase ${field} for ${name}`
}

/**
 * rc-input-number hard-codes aria-label "Increase Value" on the handler.
 * Inner upHandler spans are ignored. Stamp the product label on the buttons.
 */
export const applyStockTakeStepperAria = (root, field, title) => {
  if (!root?.querySelector) return
  const up = root.querySelector('.ant-input-number-handler-up')
  const down = root.querySelector('.ant-input-number-handler-down')
  if (up) {
    up.setAttribute('aria-label', stockTakeStepperAria(field, title, 1))
  }
  if (down) {
    down.setAttribute('aria-label', stockTakeStepperAria(field, title, -1))
  }
}

export const StockTakeInputNumber = ({ field, productTitle, ...props }) => {
  const wrapRef = useRef(null)
  useLayoutEffect(() => {
    applyStockTakeStepperAria(wrapRef.current, field, productTitle)
  })
  return (
    <span ref={wrapRef}>
      <InputNumber
        aria-label={stockTakeFieldAria(field, productTitle)}
        {...props}
      />
    </span>
  )
}
